function RightChevron({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '12'} height=${(dimensions * 5) / 3 || '12'} viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.230469 18.23L2.00047 20L12.0005 10L2.00047 0L0.230469 1.77L8.46047 10L0.230469 18.23Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default RightChevron;
